/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalLinkIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ExternalLinkIndicator({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content/Launchers/Content/App/AppAction/ExternalLinkIndicator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let launcherTypeValueData = fromData.useDataFormat({ viewPath,
context: 'launcher',
path: 'type',
format: fromHelpers.isContent,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(launcherTypeValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}